import { ORGANIC_QUILTED_PILLOW } from '@/constants/product-codes'
import ImageByContent from '@/components/ImageByContent'
import AdditionalFeaturesPDP from '@/components/AdditionalFeaturesPDP'
import ProductOverviewAccordion from '@/components/ProductOverviewAccordion'

const OrganicQuiltedPillow = () => {
    const productCode = ORGANIC_QUILTED_PILLOW

    return (
        <>
            <ProductOverviewAccordion />
            <ImageByContent
                productCode={`${ORGANIC_QUILTED_PILLOW}-pillow-height`}
                sectionName='whichPillowHeight'
                backgroundColorClass='u-bgColor--contrast2'
                imageSide='left'
            />
            <ImageByContent
                contentClassName='u-marginTop--none'
                productCode={`${productCode}`}
                sectionName='organicQuiltedPillowDiagram'
                imageSide='right'
            />
            <ImageByContent
                productCode={`${productCode}--why-natural`}
                sectionName='saatvaPillowWhyNatural'
                backgroundColorClass='u-bgColor--contrast1'
                imageSide='left'
            />
            <AdditionalFeaturesPDP productCode={productCode} />
        </>
    )
}

export default OrganicQuiltedPillow
